import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";

// to be moved to separate file
export interface Announce {
    topic: string,
    message: any
}
// to be moved to separate file
export interface searchOptions {
    storyId: string;
    searchKeyword: string;
    route: string;
    storyValue: string;
}
@Injectable()
export class DataService {
    //private refreshToken: boolean = false;
    private loggedIn: boolean = false;
    private announce: Announce = {
        topic: '',
        message: null
    };
    private search: searchOptions = {
        storyId: '',
        searchKeyword: '',
        route: '',
        storyValue: ''
    };
    private story = {
        storyId: '',
        value: '',
        route:''
    };
    private subsection = '';
    private routeInfo = {
        route: ''
    };

    constructor() { }
    // private refreshTokenInitiated = new BehaviorSubject<boolean>(this.refreshToken);
    // public refreshTokenInstance = this.refreshTokenInitiated.asObservable();

    private announcer = new BehaviorSubject<Announce>(this.announce);
    public announcement = this.announcer.asObservable();

    private searchAnnounce = new BehaviorSubject<searchOptions>(this.search);
    public searchAnnouncement = this.searchAnnounce.asObservable();

    private changeStoryInitiated = new BehaviorSubject<any>(this.story);
    public changeStoryInstance = this.changeStoryInitiated.asObservable();

    private userLoggedInSubject = new BehaviorSubject<boolean>(this.loggedIn);
    public userLoggedInstance = this.userLoggedInSubject.asObservable();

    private subsectionInitiate = new BehaviorSubject<any>(this.subsection);
    public subsectionInstance = this.subsectionInitiate.asObservable();

    private routeInformSubject =  new BehaviorSubject<any>(this.routeInfo);
    public routeInfoInstance  = this.routeInformSubject.asObservable();
    // setRefreshToken(data: boolean) {
    //     this.refreshTokenInitiated.next(data);
    // }
    annouceRoute(route) {
        this.routeInformSubject.next(route);
    }

    doAnnouncement(announce: Announce) {
        this.announcer.next(announce);
    }
    setSubSection(subsection: string) {
      this.subsectionInitiate.next(subsection);
    }
    //observable for change in ALL ACCOUNT dropdown
    allAccountdropdownChangeAnnouncment(search: searchOptions) {
        this.searchAnnounce.next(search)
    }

    //observable for change in Global dropdown
    changeStory(storyId, value, route) {
        this.changeStoryInitiated.next({ storyId, value, route });
    }

    stopGlobalDrodownStream() {
        this.changeStoryInitiated.complete();
    }
    public userLoggedIn(val: boolean) {
        this.userLoggedInSubject.next(val);
    }
}
